/**
 * Утиліта для оновлення URL search params через Next.js router
 */

export function createSearchParamsUpdater(
  searchParams: URLSearchParams,
  pathname: string
) {
  return {
    /**
     * Оновлює параметр в URL
     * @param key - ключ параметра
     * @param value - значення (якщо null або undefined, параметр видаляється)
     * @param resetPage - чи скидати сторінку на 1 (за замовчуванням true)
     */
    update: (
      key: string,
      value: string | null | undefined,
      resetPage: boolean = true
    ): string => {
      const params = new URLSearchParams(searchParams.toString());

      if (value === null || value === undefined || value === "") {
        params.delete(key);
      } else {
        params.set(key, value);
      }

      if (resetPage) {
        params.set("page", "1");
      }

      return `${pathname}?${params.toString()}`;
    },
  };
}
